import { en } from './en'
import { fr } from './fr'

export const allOpportunitiesPage = {
  en,
  fr,
}
